import React from "react";
import { unlocks } from "../b5-unlocks/getUserUnlocks.js";

export default function(props, state) {
  //Don't show if no new unlocks
  if (props.newlyUnlockedIds.length === 0) {
    return null;
  }

  const containerStyle = {
    textAlign: "center"
  };
  const headingStyle = {
    color: "#A897B5",
    fontSize: "0.8em"
  };

  const unlockStyle = {
    unlock: {
      marginBottom: "1em"
    },
    icon: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: "2em"
    },
    unlockName: {
      display: "inline-block",
      verticalAlign: "middle",
      fontSize: "1.1em",
      textTransform: "uppercase"
    }
  };

  return (
    <div style={containerStyle}>
      <div style={headingStyle}>You've earned:</div>
      {props.newlyUnlockedIds.map((id, index) => {
        const unlockModel = unlocks.find(unlock => unlock.id === id);
        return (
          <div style={unlockStyle.unlock} key={index}>
            <span style={unlockStyle.icon} className="UnlockIconContainer">
              {unlockModel.icon("3.5em")}
            </span>
            <span style={unlockStyle.unlockName}>
              {unlockModel.name}!
            </span>
          </div>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/battle/NewlyUnlockedList.js